import { render, staticRenderFns } from "./bed_list.vue?vue&type=template&id=ed406900&scoped=true&"
import script from "./bed_list.vue?vue&type=script&lang=js&"
export * from "./bed_list.vue?vue&type=script&lang=js&"
import style0 from "./bed_list.vue?vue&type=style&index=0&id=ed406900&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed406900",
  null
  
)

export default component.exports